import { HTMLAttributes, useCallback, useRef } from "react";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";

import { ArrowLeft } from "../../../assets/icons/ArrowLeft";
import { CloseIcon } from "../../../assets/icons/CloseIcon";
import { AuthModalForm } from "../../atoms/AuthModalForm";
import {
  AuthenticationModalContainer,
  AuthenticationModalContent,
  AuthenticationModalControls,
} from "./styles";

interface IAuthenticationModalProps extends HTMLAttributes<HTMLElement> {
  onCloseAuthModal: () => void;
  onReturnModalStep: () => void;
  showLoginModal: boolean;
  shouldShowArrowNavigation: boolean;
}

const AuthenticationModal = ({
  children,
  showLoginModal,
  onCloseAuthModal,
  onReturnModalStep,
  shouldShowArrowNavigation,
}: IAuthenticationModalProps) => {
  const backgroundRef = useRef();

  const handleCloseAuthModal = useCallback(() => {
    if (onCloseAuthModal) onCloseAuthModal();
  }, [onCloseAuthModal]);

  const handleReturnModalStep = useCallback(() => {
    if (onReturnModalStep) onReturnModalStep();
  }, [onReturnModalStep]);

  const handleBackgroundClick = ({ target }) => {
    const clickedInBackground = target === backgroundRef.current;
    if (clickedInBackground) onCloseAuthModal();
  };

  return (
    <AuthenticationModalContainer
      showLoginModal={showLoginModal}
      ref={backgroundRef}
      onClick={handleBackgroundClick}
    >
      <AuthenticationModalContent showLoginModal={showLoginModal}>
        <AuthenticationModalControls>
          <div>
            {shouldShowArrowNavigation ? (
              <AuthModalForm.Button
                onClick={handleReturnModalStep}
                id="auth-navigation"
                variant="transparent"
              >
                <ArrowLeft />
              </AuthModalForm.Button>
            ) : null}
          </div>

          <div>
            <AuthModalForm.Button
              onClick={handleCloseAuthModal}
              id="auth-close"
              data-testid="close"
              variant="transparent"
            >
              <CloseIcon />
            </AuthModalForm.Button>
          </div>
        </AuthenticationModalControls>

        <ComponentErrorBoundary>{children}</ComponentErrorBoundary>
      </AuthenticationModalContent>
    </AuthenticationModalContainer>
  );
};

export default AuthenticationModal;
